import { useState } from 'react'
import { Toggle } from 'components'
import { optionsLevels } from 'helper/utils'
import { useStorage } from 'hooks/index'
import MigrarContrato from './MigrarContrato'
import Aditivo from './Aditivo'
import NovoResgate from './Resgate'

const AdicionaisContrato = (props: any) => {
  const { data } = props
  const [toggle, setToggle] = useState('migrar')
  const [aditivoData, setAditivoData] = useState({})
  const [user] = useStorage('User')

  //    [
  //   'Migrar contrato',
  //    'migrar',
  //    // !['OWNER', 'DIRECTOR', 'GESTOR', 'SPECGESTOR'].includes(
  //   optionsLevels[user.level]
  // ),
  // ],
  // Migrar contrato disable

  const toggleOptionList = [
    [
      'Histórico',
      'historico',
      true,
      // !['OWNER', 'DIRECTOR', 'GESTOR', 'SPECIALIST', 'SPECGESTOR'].includes(
      //   optionsLevels[user.level]
      // ),
    ],
    [
      'Nova Resgate',
      'resgate',
      true,
      // !['OWNER', 'DIRECTOR', 'GESTOR', 'SPECGESTOR'].includes(
      //   optionsLevels[user.level]
      // ),
    ],

    [
      'Aditivo de contrato',
      'aditivo',
      true,
      // !['OWNER', 'DIRECTOR', 'GESTOR', 'SPECIALIST', 'SPECGESTOR'].includes(
      //   optionsLevels[user.level]
      // ),
    ],
  ]

  return (
    <>
      <h4 className="detalhes-captacao-subtitle">Mais opções</h4>
      <div className="detalhes-botoes-container" style={{ marginLeft: 6 }}>
        <Toggle
          options={toggleOptionList}
          toggle={toggle}
          setToggle={setToggle}
        />
      </div>
      {
        // Se o valor de "toggle" for "migrar",
        // renderiza o componente MigrarContrato passando a prop "data"
        // toggle === 'migrar' && <MigrarContrato data={data} />
      }
      {toggle === 'aditivo' && <Aditivo />}
      {toggle === 'resgate' && <NovoResgate />}
    </>
  )
}

export default AdicionaisContrato
